import type { Fornecedor } from '@/features/fornecedor/types/Fornecedor';

export function FornecedorOption({ fornecedor }: { fornecedor: Fornecedor }) {
    return (
        <div className='whitespace-normal'>
            <div className='font-bold'>{fornecedor.pessoa.pes_nome_razaosocial}</div>

            <div className='text-sm opacity-70'>
                {fornecedor.pessoa.pes_nome_fantasia}
                <div>Código: {fornecedor.for_codigoindividual}</div>
                {fornecedor.pessoa.pes_cnpj_cpf && (
                    <div>Documento: {fornecedor.pessoa.pes_cnpj_cpf}</div>
                )}
            </div>
        </div>
    );
}
